import { GridLayout, GridItem } from '../GridLayout/GridLayout';

import { PaperProps } from './Paper.decl';

import { Box, Typography, useTheme, LockedFilled, Flex, Spacer } from '@aircall/tractor';
import { useTranslation } from 'react-i18next';

export function Paper({
  children,
  footer,
  title,
  subtitle,
  fluid,
  disabled,
  ...boxProps
}: PaperProps) {
  const { colors, radii } = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      borderRadius={radii[8]}
      maxWidth={1372}
      border={`1px solid ${colors.grey.base}`}
      backgroundColor={colors.base.white}
      {...(disabled && { cursor: 'not-allowed' })}
      {...boxProps}
    >
      <GridLayout width='100%' gridRowGap='m' gridColumnGap={{ _: 'm', md: 'l' }} p='m'>
        {title && (
          <GridItem xs={12} gridRow={1}>
            <Spacer alignItems='center' space='xs'>
              <Typography
                variant='displayS'
                data-test='paper-title'
                mb={subtitle ? '-8px' : 0}
                display='flex'
                color={disabled ? 'text.light' : 'text.base'}
              >
                {title}
                {disabled && (
                  <Flex alignItems='center' ml={34}>
                    <LockedFilled color={colors.text.dark} size={16} />
                    <Typography fontSize={14} ml={10} color={colors.text.dark} fontWeight={500}>
                      {t('number_details.settings.upgrade_feature.title')}
                    </Typography>
                  </Flex>
                )}
              </Typography>
            </Spacer>
          </GridItem>
        )}
        {subtitle && (
          <GridItem xs={12} lg={8} gridRow={2}>
            <Typography
              variant='body'
              data-test='paper-subtitle'
              color={disabled ? 'text.light' : 'text.base'}
            >
              {subtitle}
            </Typography>
          </GridItem>
        )}
        <GridItem xs={12} lg={fluid ? 12 : 8}>
          {children}
        </GridItem>
      </GridLayout>
      {footer}
    </Box>
  );
}
